module.exports = __webpack_public_path__ + "assets/redpack-bottom-bg-fb104efe.png";